import { createBrowserRouter } from 'react-router-dom';
import React, {Suspense} from "react";
import GuestLayout from './pages/layouts/GuestLayout';
//import SearchResult from "./pages/clients/SearchResult";
//import Article from "./pages/clients/Article";
//import Place from './pages/clients/Place';
//import VehicleCardClient from './pages/clients/VehicleCard';
//import Profile from './pages/clients/Profile';

const Place = React.lazy(()=>import('./pages/clients/Place'));
const VehicleCardClient = React.lazy(()=>import('./pages/clients/VehicleCard'));
const Profile = React.lazy(()=>import('./pages/clients/Profile'));

//import ProtectedLayout from './pages/layouts/ProtectedLayout';*/
const ProtectedLayout = React.lazy(()=>import('./pages/layouts/ProtectedLayout'));

//const GuestLayout = React.lazy(()=>import('./pages/layouts/GuestLayout'));
//import App from './App'
/*import BusinessAbout from "./pages/business/BusinessAbout";*/
const BusinessAbout = React.lazy(()=>import('./pages/business/BusinessAbout'));
/*import Dashboard from "./pages/business/Dashboard";*/
const Dashboard = React.lazy(()=>import('./pages/business/Dashboard'));
/*import Worktime from "./pages/business/Worktime";*/
const Worktime = React.lazy(()=>import('./pages/business/Worktime'));
/*import RentRules from "./pages/business/RentRules";*/
const RentRules = React.lazy(()=>import('./pages/business/RentRules'));
/*import Seasons from "./pages/business/Seasons";*/
const Seasons = React.lazy(()=>import('./pages/business/Seasons'));
/*import Addons from "./pages/business/Addons";*/
const Addons = React.lazy(()=>import('./pages/business/Addons'));
/*import BankInformation from "./pages/business/BankInformation";*/
const BankInformation = React.lazy(()=>import('./pages/business/BankInformation'));
/*import Inbox from "./pages/business/Inbox";*/
const Inbox = React.lazy(()=>import('./pages/business/Inbox'));
/*import Orders from "./pages/business/Orders";*/
const Orders = React.lazy(()=>import('./pages/business/Orders'));
/*import Calendar from "./pages/business/Calendar";*/
const Calendar = React.lazy(()=>import('./pages/business/Calendar'));
/*import Garage from "./pages/business/Garage";*/
const Garage = React.lazy(()=>import('./pages/business/Garage'));
/*import Motorcycles from "./pages/business/Motorcycles";*/
const Motorcycles = React.lazy(()=>import('./pages/business/Motorcycles'));
/*import Reviews from "./pages/business/Reviews";*/
const Reviews = React.lazy(()=>import('./pages/business/Reviews'));
/*import Messages from "./pages/clients/Messages";*/
const Messages = React.lazy(()=>import('./pages/clients/Messages'));
/*import Support from "./pages/business/Support";*/
const Support = React.lazy(()=>import('./pages/business/Support'));
/*import Tutorial from "./pages/business/Tutorial";*/
const Tutorial = React.lazy(()=>import('./pages/business/Tutorial'));

/*import Garages from "./pages/business/Garages";*/
const Garages = React.lazy(()=>import('./pages/business/Garages'));
/*import MessagesBusiness from "./pages/business/Messages";*/
const MessagesBusiness = React.lazy(()=>import('./pages/business/Messages'));

/*import AddNewMotorcycle  from "./pages/business/service/AddNewMotorcycle";*/
const AddNewMotorcycle = React.lazy(()=>import('./pages/business/service/AddNewMotorcycle'));




const SearchResult = React.lazy(()=>import('./pages/clients/SearchResult'));

/*import ClientOrders from "./pages/clients/Orders";*/
const ClientOrders = React.lazy(()=>import('./pages/clients/Orders'));
/*import OrderCard from "./pages/clients/OrderCard";*/
const OrderCard = React.lazy(()=>import('./pages/clients/OrderCard'));


const Article = React.lazy(()=>import('./pages/clients/Article'));

/*import SuperadminLayout from "./pages/layouts/SuperadminLayout";*/
const SuperadminLayout = React.lazy(()=>import('./pages/layouts/SuperadminLayout'));
/*import ResetEmailPassword from "./pages/clients/ResetEmailPassword";*/
const ResetEmailPassword = React.lazy(()=>import('./pages/clients/ResetEmailPassword'));



const ShopCard = React.lazy(()=>import('./pages/business/service/ShopCard'));

const VehicleCard = React.lazy(()=>import('./pages/business/service/VehicleCard'));

const Texts = React.lazy(()=>import('./pages/superadmin/Texts'));

const BusinessLayout = React.lazy(()=>import('./pages/layouts/BusinessLayout'));

const router = createBrowserRouter([
    {
        path: '/',
        element: <GuestLayout />,
        children: [
            {path: ":lng/", element: <Suspense fallback={<div>Loading...</div>}><Place /></Suspense>},
            {path: ":lng/rent/:type/:place", element: <Suspense fallback={<div>Loading...</div>}><Place /></Suspense>},
            {path: "/article/:article", element: <Suspense fallback={<div>Loading...</div>}><Article /></Suspense>},
            {path: ":lng/article/:article", element: <Suspense fallback={<div>Loading...</div>}><Article /></Suspense>},
            {path: "/search-result", element: <Suspense fallback={<div>Loading...</div>}><SearchResult /></Suspense>},
            {path: "/orders/", element: <Suspense fallback={<div>Loading...</div>}><ClientOrders /></Suspense>},
            {path: "/profile/", element: <Suspense fallback={<div>Loading...</div>}><Profile /></Suspense>},
            {path: "/orders/:id", element: <Suspense fallback={<div>Loading...</div>}><OrderCard /></Suspense>},
            {path: "/messages/", element: <Suspense fallback={<div>Loading...</div>}><Messages /></Suspense>},
            {path: "/vehicle-card/:id", element: <Suspense fallback={<div>Loading...</div>}><VehicleCardClient /></Suspense>},
            {path: "/",element: <Suspense fallback={<div>Loading...</div>}><Place /></Suspense>},
                    {path: 'login',element: <Suspense fallback={<div>Loading...</div>}><Place /></Suspense>},
            {path: "/business/about",  element: <Suspense fallback={<div>Loading...</div>}><BusinessAbout /></Suspense>},
            {path: "/email-password-reset",  element: <Suspense fallback={<div>Loading...</div>}><ResetEmailPassword /></Suspense>},
        ],
    },
    {
        path: '/',
        element: <ProtectedLayout />,
        children: [
            {   path: "/business/",
                element: <BusinessLayout />,
                children : [
                    {path: '/business/work/dashboard', element: <Suspense fallback={<div>Loading...</div>}><Dashboard /></Suspense>},
                    {path: "/business/config/shop", element: <Suspense fallback={<div>Loading...</div>}><ShopCard /></Suspense>},
                    {path: "/business/config/shop/new", element: <Suspense fallback={<div>Loading...</div>}><ShopCard new={'new'} /></Suspense>},
                    {path: "/business/config/garages", element: <Suspense fallback={<div>Loading...</div>}><Garages /></Suspense>},
                    {path: "/business/config/work-time", element: <Suspense fallback={<div>Loading...</div>}><Worktime /></Suspense>},
                    {path: "/business/config/rent-rules", element: <Suspense fallback={<div>Loading...</div>}><RentRules /></Suspense>},
                    {path: "/business/config/seasons", element: <Suspense fallback={<div>Loading...</div>}><Seasons /></Suspense>},
                    {path: "/business/config/addons", element: <Suspense fallback={<div>Loading...</div>}><Addons /></Suspense>},
                    {path: "/business/config/bank-information", element: <Suspense fallback={<div>Loading...</div>}><BankInformation /></Suspense>},
                    {path: "/business/work/inbox", element: <Suspense fallback={<div>Loading...</div>}><Inbox /></Suspense>},
                    {path: "/business/work/orders", element: <Suspense fallback={<div>Loading...</div>}><Orders /></Suspense>},
                    {path: "/business/work/calendar", element: <Suspense fallback={<div>Loading...</div>}><Calendar /></Suspense>},
                    {path: "/business/work/garage", element: <Suspense fallback={<div>Loading...</div>}><Garage /></Suspense>},
                    {path: "/business/work/motorcycles", element: <Suspense fallback={<div>Loading...</div>}><Motorcycles /></Suspense>},
                    {path: "/business/work/reviews", element: <Suspense fallback={<div>Loading...</div>}><Reviews /></Suspense>},
                    {path: "/business/work/messages", element: <Suspense fallback={<div>Loading...</div>}><MessagesBusiness /></Suspense>},
                    {path: "/business/support", element: <Suspense fallback={<div>Loading...</div>}><Support /></Suspense>},
                    {path: "/business/tutorial", element: <Suspense fallback={<div>Loading...</div>}><Tutorial /></Suspense>},
                    {path: "/business/config/shop/add-new-shop", element: <Suspense fallback={<div>Loading...</div>}><ShopCard /></Suspense>},
                    /*{path: "/business/work/reports", element: <Report />},*/
                    {path: "/business/work/garage/:vehicleType/:id", element: <Suspense fallback={<div>Loading...</div>}><VehicleCard /></Suspense>},
                    {path: "/business/work/garage/add-new-motorcycle", element: <Suspense fallback={<div>Loading...</div>}><AddNewMotorcycle /></Suspense>},




                ],

            },
            {
                path: "/superadmin/",
                element: <SuperadminLayout/>,
                children : [
                    {path: "/superadmin/texts/", element: <Texts />},
                    ]
            }


        ],
    },
]);

export default router;
